/**
 * NutritionContent - 营养成分表渲染组件
 */

import React from 'react';
import { isNutritionEmptyPlaceholder, NUTRITION_EMPTY_PLACEHOLDER } from '../../utils/nutritionUtils';

export default function NutritionContent({ data, mode = 'view', templateType }) {
  if (!data || !data.items || data.items.length === 0) return null;

  const formatValueCell = (item) => {
    if (isNutritionEmptyPlaceholder(item?.per100g)) {
      return NUTRITION_EMPTY_PLACEHOLDER;
    }
    return `${item?.per100g ?? ''}${item?.unit ?? ''}`;
  };

  const isBlueWhiteTemplate = templateType === 'blue-white-template';
  const isStandardTemplate = templateType === 'standard-food-label';
  const ts = data.tableStyle || {};

  // 获取标题配置
  const titleConfig = data.titleConfig || {};
  const shouldShowCustomTitle = titleConfig.enabled && (titleConfig.chinese || titleConfig.english);

  // 根据模板类型设置默认颜色
  const defaultBgColor = isBlueWhiteTemplate ? '#1e90ff' : (isStandardTemplate ? '#5C4A37' : '#1e90ff');

  // 渲染标题
  const renderTitle = () => {
    if (shouldShowCustomTitle) {
      if (isBlueWhiteTemplate) {
        return (
          <h3
            className="content-section-heading blue-white-title"
            style={{
              backgroundColor: titleConfig.bgColor || defaultBgColor,
              color: titleConfig.textColor || '#ffffff'
            }}
          >
            {titleConfig.english && (
              <div className="blue-white-title-en">{titleConfig.english}</div>
            )}
            <div className="blue-white-title-cn">{titleConfig.chinese || '营养成分表'}</div>
          </h3>
        );
      }

      const resolvedBgColor = (() => {
        const base = titleConfig.bgColor || defaultBgColor;
        if (isStandardTemplate && base === '#1e90ff') {
          return '#5C4A37';
        }
        return base;
      })();
      return (
        <h3
          className="content-section-heading"
          style={{
            backgroundColor: resolvedBgColor,
            color: titleConfig.textColor || '#ffffff',
            padding: '8px 12px',
            borderRadius: '6px',
            marginBottom: '12px'
          }}
        >
          {titleConfig.english && (
            <div style={{ fontSize: 12, opacity: 0.9, lineHeight: 1.2 }}>
              {titleConfig.english}
            </div>
          )}
          <div style={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}>
            {titleConfig.chinese || '营养成分表'}
          </div>
        </h3>
      );
    }

    return <h3 className="content-section-heading">营养成分表</h3>;
  };

  const table = (
    <div className="label-content-nutrition">
      <table className="nutrition-table" style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr style={{ background: ts.headBgColor }}>
            <th style={{ color: ts.headTextColor }}>项目</th>
            <th style={{ color: ts.headTextColor }}>每100克</th>
            <th style={{ color: ts.headTextColor }}>NRV%</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((item, idx) => (
            <tr key={idx}>
              <td style={{ color: ts.textColor, borderBottom: ts.rowBorderColor ? `1px solid ${ts.rowBorderColor}` : undefined, padding: (ts.cellPadding ?? 10) + 'px' }}>{item.name}</td>
              <td style={{ color: ts.textColor, borderBottom: ts.rowBorderColor ? `1px solid ${ts.rowBorderColor}` : undefined, padding: (ts.cellPadding ?? 10) + 'px' }}>{formatValueCell(item)}</td>
              <td style={{ color: ts.textColor, borderBottom: ts.rowBorderColor ? `1px solid ${ts.rowBorderColor}` : undefined, padding: (ts.cellPadding ?? 10) + 'px' }}>{item.nrv}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div
        style={{
          marginTop: 8,
          fontSize: 12,
          color: '#4b5563',
          paddingLeft: 12
        }}
      >
        儿童青少年应避免过量摄入盐油糖。
      </div>
    </div>
  );

  // 蓝白：标题在卡片外；默认/其它：标题在卡片内
  if (isBlueWhiteTemplate) {
    return (
      <>
        {renderTitle()}
        {table}
      </>
    );
  }
  return (
    <div className="label-content-nutrition">
      {renderTitle()}
      {table.props.children}
    </div>
  );
}
